module.exports = __webpack_public_path__ + "static/media/ore3.png.2517597b.jpg";